<template>
  <div>
	<dl v-if="!json.init" class="spe-general-goods" ref="speGeneralGoods" :style="commonStyle" :ddt-area="`component_${json.floorId}_普通商品组件`" ddt-expose="on">
		<!-- 标题背景(1文案标题，2标题图) -->
		<dt
      v-if="jdata.header.type == 1 || jdata.header.type == 2"
      :style="headerStyle"
      :data-area="pt()"
      :data-pos="`component_${json.floorId}_普通商品组件.标题_点击跳转`"
      :data-desc="jdata.header.title || ''"
      :dd_name="`${pt()}.component_${json.floorId}_普通商品组件.标题_点击跳转.${jdata.header.title || ''}`"
      :ddt-click="`${pt()}.component_${json.floorId}_普通商品组件.标题_点击跳转.${jdata.header.title || ''}`"
      ddt-pit="标题_点击跳转"
      :ddt-src="jdata.header.title || ''"
      ddt-expose="on"
      @click="$sys.dict.href_for_type(jdata.header.jumpContent, jdata.header.jumpType)"
    >
			<div v-if="jdata.header.type == 1">
				<label :style="{ color: jdata.header.titleColor || jdata.header.titleDefaultColor, 'text-align': jdata.header.moreText?'left':'center' }">{{ jdata.header.title }}</label>
				<span :style="{ color: jdata.header.moreTextColor || jdata.header.moreTextDefaultColor }" v-if="jdata.header.moreText">{{ jdata.header.moreText }}<i class="iconfont">&#xe669;</i></span>
			</div>
		</dt>
    <dd :style="ddStyle">
    <transition-group name="fade" class="animate-fade" :class="{ column_type_1: json.compStyle == 1, column_type_2: json.compStyle == 2 }">
      <div class="p_box" v-for="el in jdata.products" :key="el.productId" v-if="jdata.products && jdata.products.length > 0 && el && el.imgUrl" :data-comptype="json.compStyle" :el="el">
          <div
            class="product"
            @click="$sys.dict.href(el.link)"
            :data-area="pt()"
            :data-pos="`component_${json.floorId}_普通商品组件.商品${el.productId}_点击跳转`"
            :data-desc="el.title"
            :dd_name="`${pt()}.component_${json.floorId}_普通商品组件.商品${el.productId}_点击跳转.${el.title}`"
            :ddt-click="`${pt()}.component_${json.floorId}_普通商品组件.商品${el.productId}_点击跳转.${el.title}`"
            :ddt-pit="`商品${el.productId}_点击跳转`"
            :ddt-src="el.title"
            ddt-expose="on"
          >
						<div class="img-wrap">
							<img class="img" v-lazy="el.imgUrl" />
							<img v-if="jdata.showNewPrice" class="new-cust-tag" src="https://img62.ddimg.cn/2024/11/27/2024112719453625946.png" />
						</div>
            <h2 class="line2" v-show="el.title">{{ el.title }}</h2>
            <h3 class="line1" v-show="el.authorName || el.publisher">{{ el.authorName || el.publisher }}</h3>
            <div class="labels" v-show="el.labels && el.labels.length>0">
              <span v-for="(la, i) in el.labels" :key="i" class="la" :class="'label' + (la.type || 0)">{{ la.name | label_filter }}</span>
            </div>
            <div class="price" v-if="jdata.priceType != 2 && (el.salePrice || el.discount || el.originalPrice || el.newCustPrice)">
              <div class="l">
                <div class="salePrice" v-if="el.salePrice || el.newCustPrice"><i>¥</i>{{ el.newCustPrice || el.salePrice }}</div>
                <div class="discount" v-if="el.discount">{{ el.discount }}折</div>
                <del class="originalPrice" v-if="el.originalPrice">¥{{ el.originalPrice }}</del>
              </div>
              <div class="addcart" v-if="el.showCart > 0">
                <span class="iconfont">&#xe604;</span>
              </div>
            </div>
						<div class="curve-price" v-if="jdata.priceType == 2 && (el.salePrice || el.discount || el.originalPrice || el.newCustPrice)">
              <div class="l">
                <div class="salePrice" :class="{curve1: json.compStyle == 1, curve2: json.compStyle == 2}" v-if="el.salePrice || el.newCustPrice"><i>¥</i>{{ getPriceObj(el.newCustPrice || el.salePrice).integer }}<i>{{ getPriceObj(el.newCustPrice || el.salePrice).decimal }}</i></div>
								<div class="discount" v-if="el.discount">{{ el.discount }}折</div>
                <del class="originalPrice" v-if="el.originalPrice">¥{{ el.originalPrice }}</del>
              </div>
              <div class="addcart" v-if="el.showCart > 0">
                <span class="iconfont">&#xe604;</span>
              </div>
            </div>
            <div class="ebook" v-if="el.hasOwnProperty('ebookSalePrice')">
              <template v-if="el.ebookSalePrice">
              <img src="//img61.ddimg.cn/upload_img/00610/h5m/cms-e-1597237573.png" />
              <i>¥</i>{{ el.ebookSalePrice }}
              </template>
            </div>
            <div v-if="el.pintuanInfo" class="tuan">
              <span class="person">{{ el.pintuanInfo && el.pintuanInfo[0] }}人团</span>
              <span class="num">已团{{ el.pintuanInfo && el.pintuanInfo[1] }}件</span>
            </div>
            <div v-if="el.desc" class="desc line2">
              {{ el.desc }}
            </div>
          </div>
      </div>
    </transition-group>
    </dd>
    <div class="spe_add_cart_wrap" v-if="jdata.showOnekeyAddButton && jdata.products.length <= 40">
      <div class="spe_add_cart" @click="add_cart_products">
        <img class="cart_icon" src="http://img61.ddimg.cn/upload_img/00875/h5/add_cart_01-1604284736.png">
        <span class="cart_txt">一键加购本楼层商品</span>
      </div>
    </div>
  </dl>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import { priceIntegerDecimal } from  '../assets/js/format'
import cookie from 'js-cookie';
export default {
	name: "SpeGeneralGoods",
	props: {
		json: {
			type: Object,
			default: () => ({ commonStyle: {}, header: {}, products: [] }),
		},
    pagebgcolor: {
      type: String,
      default: 'transparent'
    }
	},
	data() {
		return {
      jdata: { commonStyle: {}, header: {}, products: [] },
      num: 0,
      address: {
        province_id: '111',
        city_id: '1',
        district_id: '1110101',
        town_id: ''
      }
    };
	},
  inject: ['pt'],
	computed: {
    commonStyle() {
      let sty = {};
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor = this.pagebgcolor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      }
      return sty;
    },
		headerStyle() {
			let sty = {};
      if (this.jdata.header) {
        if (this.jdata.header.type == 1) {
          //文字
          sty.backgroundColor = this.jdata.header.backgroundColor || this.jdata.header.backgroundDefaultColor;
        } else if (this.jdata.header.type == 2) {
          //背景图
          sty.backgroundImage = `url(${this.jdata.header.backgroundImage})`;
        }
      }
			return sty;
		},
		ddStyle() {
      if(this.jdata.commonStyle.margin > 0){
        let sty = {
          padding: `0 ${this.jdata.commonStyle.margin}px`
        };
        return sty;
      }
		}
	},
	watch: {
    'json.data': {
      handler (val) {
        if (val) this.jdata = val
        else this.jdata = { commonStyle: {}, header: {}, products: [], pids: [] }
        console.log(this.jdata, 'jdata')
      },
      deep: true,
    },
  },
	mounted() {
    this.address.province_id = this.$route.query.province_id || cookie.get('MDD_province_id') || '111'
    this.address.city_id = this.$route.query.city_id || cookie.get('MDD_city_id') || '1'
    this.address.district_id = this.$route.query.district_id || cookie.get('MDD_area_id') || '1110101'
    this.address.town_id = this.$route.query.town_id || cookie.get('MDD_street_id') || ''
  },
	methods: {
		getPriceObj(price) {
			return priceIntegerDecimal(price)
		},
    async add_cart_products () {
      const pids = this.jdata.products.map(item => {return item.productId})
      const { province_id = '111', city_id = '1', district_id = '1110101', town_id = ''} = this.address
      const product_ids = pids.toString()
      const { errorMsg, errorCode } = await this.$axios.get("/shoppingcart/mobile/cart_append_products", { params: { product_ids, province_id, city_id, district_id, town_id }, headers: { cors: true } })
      if(errorCode === 0) {
        this.$toast('加购成功')
      } else {
        this.$toast(errorMsg)
      }
    }
	},
	filters: {
		label_filter(v) {
			if (v == "当当自营") {
				return "自营";
			}
			return v;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-general-goods {
  background-repeat: repeat-y;
  background-position: left top;
  background-size: 100%;
	dt {
		height: 84px;
    background-size: 100% 100%;
		display: flex;
		> div {
			padding: 0 40px;
			display: flex;
			align-items: center;
			flex: 1;
			label {
				flex: 1;
				font-size: 34px;
				font-weight: bold;
			}
			span {
				font-size: 24px;
				font-weight: bold;
			}
		}
	}
	dd {
    flex: 1;
    .animate-fade{
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      padding: 10px 14px 0 14px;
      box-sizing: border-box;
    }
		.p_box {
			box-sizing: border-box;
			padding-right: 5px;
			overflow: hidden;
			margin-bottom: 10px;
			display: flex;
			.product {
				border-radius: 8px;
				overflow: hidden;
				background: #fff;
				padding-bottom: 20px;
				.img-wrap {
					position: relative;
					.img {
						width: 100%;
					}

					.new-cust-tag {
						width: 122px;
						height: 44px;
						position: absolute;
						left: -1px;
						top: -1px;
						border-top-left-radius: 8px;
					}
				}
				h2 {
					font-size: 26px;
					color: #141414;
					line-height: 36px;
					margin-top: 12px;
					padding: 0 14px;
					height:72px;
				}
				h3 {
					font-size: 22px;
					color: #828282;
					line-height: 22px;
					margin-top: 12px;
					padding: 0 14px;
					height:22px;
				}
				.labels {
					margin-top: 8px;
					padding: 0 14px;
					display: flex;
					align-items: center;
					height:36px;
					flex-wrap: wrap;
    			overflow: hidden;
					span {
						margin-right: 4px;
						margin-top: 4px;
						flex: 0 0 auto;
					}
					.la:last-of-type {
						margin-right: 0;
					}
				}
				.curve-price {
					display: flex;
					align-items: center;
					.l {
						flex: 1;
						display: flex;
						flex-direction: column;
						.salePrice {
							font-size: 30px;
							color: #ff463c;
							line-height: 30px;
							text-align: center;
							color: #FFFFFF;
							font-weight: 600;
							margin: 0 auto 12px auto;
							i {
								font-size: 22px;
							}
							&.curve1 {
								background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/bg_price_three-1681442310.png');
								background-size: 100% 100%;
								width: 190px;
								height: 73px;
								line-height: 73px;
							}
							&.curve2 {
								background-image: url('https://img62.ddimg.cn/upload_img/00834/h5/bg_price_two-1681442423.png');
								background-size: 100% 100%;
								width: 322px;
								height: 96px;
								line-height: 96px;
							}
						}
						.discount,
						.originalPrice {
							font-size: 20px;
							color: #828282;
							margin-left: 14px;
						}
					}
					.addcart {
						width: 40px;
						height: 40px;
						border-radius: 100%;
						background: rgba(0, 0, 0, 0.05);
						text-align: center;
						line-height: 40px;
						font-size: 24px;
						color: #141414;
					}
				}
				.price {
					margin-top: 16px;
					padding: 0 14px;
					display: flex;
					align-items: center;
					.l {
						flex: 1;
						display: flex;
						align-items: center;
						.salePrice {
							font-family: PingFangSC-Medium;
							font-size: 30px;
							color: #ff463c;
							line-height: 30px;
							i {
								font-size: 22px;
							}
						}
						.discount,
						.originalPrice {
							font-size: 20px;
							color: #828282;
							margin-left: 4px;
						}
					}
					.addcart {
						width: 40px;
						height: 40px;
						border-radius: 100%;
						background: rgba(0, 0, 0, 0.05);
						text-align: center;
						line-height: 40px;
						font-size: 24px;
						color: #141414;
					}
				}
				.ebook {
					margin-top: 12px;
					padding: 0 14px;
					display: flex;
					align-items: center;
					font-size: 20px;
					color: #1cae9b;
					line-height: 20px;
					height:20px;
					img {
						width: 20px;
						height: 20px;
						margin-right: 4px;
					}
				}
				.tuan {
					margin-top: 12px;
					padding: 0 0.14rem;
					height:40px;
					.person {
						display: inline-block;
						font-size: 0.2rem;
						line-height: 0.24rem;
						padding: 0.02rem 0.04rem 0 0.04rem;
						margin-right: 0.08rem;
						color: #ff463c;
						border-radius: 0.04rem;
						border: 0.02rem solid #ff463c;
					}
					.num {
						display: inline-block;
						font-size: 0.22rem;
						line-height: 0.3rem;
						color: #828282;
					}
				}
				.desc {
          border-top: 1px dashed #e9e9e9;
					padding-top: 14px;
          margin: 0 0.14rem;
					height: 0.7rem;
					line-height: 0.36rem;
					font-size: 0.24rem;
					color: #d0b28f;
				}
			}
		}
	}
	.column_type_1 {

		.p_box {
			flex: 0 0 33.333%;
			padding: 0 5px;
			.product {
			}
		}
		.p_box:nth-of-type(3n + 2) {
			/* padding: 0 5px; */
		}
		.p_box:nth-of-type(3n + 3) {
			/* padding-right: 0; */
			/* padding-left: 5px; */
		}
	}
	.column_type_2 {

		.p_box {
			flex: 0 0 50%;
			padding-right: 5px;
			.product {
			}
		}
		.p_box:nth-of-type(2n) {
			padding-right: 0;
			padding-left: 5px;
		}
	}

  .fade-enter-active {
    transition: opacity 1s;
  }
  .fade-enter /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .fade-enter-to {
    opacity: 1;
  }
  .spe_add_cart_wrap {
    background-color: #ffffff;
    padding: 16px 24px;
    .spe_add_cart {
      display: flex;
      line-height: 84px;
      height: 84px;
      justify-content: center;
      align-items: center;
      border-radius: 2.86rem;
      border: 1px solid #F22D39;
      .cart_icon {
        height: 44px;
        width: 44px;
        margin-right: 1px;
      }
      .cart_txt {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 28px;
        color: #F2303C;
        letter-spacing: 0px;
      }
    }
  }
}
</style>
